var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalEvs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 172,
    viewBox: "0 0 288 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3559_21736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.631 40.7803L160.115 23.3284",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.11,
    cy: 39.2566,
    rx: 2.03754,
    ry: 10.2426,
    transform: "rotate(4.29798 117.11 39.2566)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.953 29.0753C125.468 29.8459 142.444 33.0512 150.234 39.708C159.971 48.0291 145.985 51.2158 136.778 51.1273C129.413 51.0565 120.136 49.9765 116.418 49.4454",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.386 50.9512C140.781 51.8291 141.378 54.0062 140.605 55.6919C139.963 57.0937 133.13 75.3304 128.107 88.7954C126.336 93.5417 126.541 98.7939 128.667 103.392L133.071 112.914C136.179 119.636 142.91 123.939 150.316 123.939H170.306M131.43 50.9512C111.844 76.7201 102.359 95.7354 101.501 104.281C101.426 105.022 101.853 105.686 102.472 106.101C110.302 111.356 118.8 129.774 122.988 140.684C123.592 142.259 125.088 143.311 126.774 143.311C142.336 143.311 165.205 143.311 184.236 143.311",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.663 105.098C95.1275 105.018 81.8645 108.318 79.0296 121.843C78.8188 122.848 79.4905 123.813 80.4906 124.049C84.3771 124.966 87.7525 125.766 90.6302 126.449C98.5571 128.332 105.343 133.2 112.089 137.768C115.913 140.358 120.569 142.557 125.808 143.201",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.2289,
    cy: 140.04,
    r: 5.51257,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.818 126.759C85.897 128.275 81.5201 133.646 81.5201 140.04C81.5201 147.611 87.6578 153.749 95.2289 153.749C102.8 153.749 108.938 147.611 108.938 140.04C108.938 138.231 108.587 136.503 107.951 134.922",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.74 140.399C116.74 152.217 107.046 161.437 95.2289 161.437C83.4116 161.437 73.8317 151.857 73.8317 140.04C73.8317 133.594 76.477 128.003 80.9855 124.081",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.979 161.018C191.18 161.018 182.398 153.637 180.616 143.379",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.5 124.447H208.737",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.5 127.697H208.737",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.5 130.948H208.737",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.035 23.0951C164.035 24.7042 163.647 26.1366 163.046 27.1499C162.438 28.174 161.67 28.6902 160.919 28.6902C160.168 28.6902 159.4 28.174 158.793 27.1499C158.191 26.1366 157.804 24.7042 157.804 23.0951C157.804 21.486 158.191 20.0536 158.793 19.0403C159.4 18.0162 160.168 17.5 160.919 17.5C161.67 17.5 162.438 18.0162 163.046 19.0403C163.647 20.0536 164.035 21.486 164.035 23.0951Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.421 40.7803L115.332 36.3877M132.905 23.3284L124.225 29.7786",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.8997,
    cy: 39.2566,
    rx: 2.03754,
    ry: 10.2426,
    transform: "rotate(4.29798 89.8997 39.2566)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.743 29.0753C96.3441 29.6497 107.202 31.5767 115.594 35.2776M89.2083 49.4454C92.9261 49.9765 102.203 51.0565 109.568 51.1273C112.884 51.1592 116.821 50.7661 120.045 49.8612",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.176 50.9512C113.571 51.8291 114.168 54.0062 113.395 55.6919C112.753 57.0937 105.92 75.3304 100.897 88.7954C99.1264 93.5417 99.3309 98.7939 101.457 103.392L101.608 103.718M104.22 50.9512C84.6341 76.7201 75.1484 95.7354 74.2905 104.281C74.216 105.022 74.6477 105.688 75.2662 106.104C77.6399 107.698 80.0749 110.502 82.4325 113.939",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4533 105.098C67.9173 105.018 54.6544 108.318 51.8194 121.843C51.6086 122.848 52.2824 123.813 53.2827 124.048C61.0285 125.869 65.6869 126.923 68.613 127.582C71.1196 128.147 73.5805 129.288 75.7529 130.66V130.66",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.0188,
    cy: 140.04,
    r: 5.51257,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6078 126.759C58.6869 128.275 54.31 133.646 54.31 140.04C54.31 147.611 60.4476 153.749 68.0188 153.749C71.2967 153.749 74.3058 152.598 76.6646 150.679",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7753 124.081C49.2668 128.003 46.6215 133.594 46.6215 140.04C46.6215 151.857 56.2014 161.437 68.0188 161.437C73.2587 161.437 78.0811 159.624 81.826 156.576",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.406 143.379C155.188 153.637 164.135 161.437 174.903 161.437C180.151 161.437 184.966 159.585 188.73 156.498",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.922 143.239C161.551 150.002 167.64 155.026 174.903 155.026C178.43 155.026 181.682 153.841 184.279 151.846L183.67 151.053C181.242 152.918 178.202 154.026 174.903 154.026C168.196 154.026 162.559 149.444 160.953 143.239H159.922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.156 143.148C170.344 145.077 172.474 146.361 174.903 146.361C177.195 146.361 179.22 145.218 180.439 143.469L181.259 144.041C179.861 146.047 177.535 147.361 174.903 147.361C172.112 147.361 169.667 145.884 168.305 143.673L169.156 143.148Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.005 99.4296H153.265C151.056 99.4296 149.265 97.6387 149.265 95.4296V95.2206C149.265 93.1598 150.831 91.4362 152.882 91.239L200.36 86.6739",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.656 99.6056H162.891C154.248 99.6056 146.693 105.44 144.509 113.803L142.317 122.19",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.825 23.0951C136.825 24.7042 136.437 26.1366 135.836 27.1499C135.228 28.174 134.46 28.6902 133.709 28.6902C132.958 28.6902 132.19 28.174 131.582 27.1499C130.981 26.1366 130.593 24.7042 130.593 23.0951C130.593 21.486 130.981 20.0536 131.582 19.0403C132.19 18.0162 132.958 17.5 133.709 17.5C134.46 17.5 135.228 18.0162 135.836 19.0403C136.437 20.0536 136.825 21.486 136.825 23.0951Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.799 40.7803L88.71 36.3877M106.284 23.3284L97.6037 29.7786",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.2782,
    cy: 39.2566,
    rx: 2.03754,
    ry: 10.2426,
    transform: "rotate(4.29798 63.2782 39.2566)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1215 29.0753C69.7225 29.6497 80.5804 31.5767 88.9726 35.2776M62.5867 49.4454C66.3046 49.9765 75.5817 51.0565 82.9466 51.1273C86.2627 51.1592 90.199 50.7661 93.4234 49.8612",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5543 50.9512C86.9493 51.8291 87.5463 54.0062 86.7737 55.6919C86.1313 57.0937 79.2986 75.3304 74.2755 88.7954C72.5048 93.5417 72.7094 98.7939 74.8357 103.392L74.9865 103.718M77.5985 50.9512C58.0126 76.7201 48.5269 95.7354 47.669 104.281C47.5945 105.022 48.0262 105.688 48.6447 106.104C51.0184 107.698 53.4534 110.502 55.811 113.939",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8318 105.098C41.2958 105.018 28.0328 108.318 25.1979 121.843C24.9871 122.848 25.6609 123.813 26.6612 124.048C34.407 125.869 39.0654 126.923 41.9915 127.582C44.4981 128.147 46.9589 129.288 49.1314 130.66V130.66",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.3973,
    cy: 140.04,
    r: 5.51257,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9863 126.759C32.0654 128.275 27.6885 133.646 27.6885 140.04C27.6885 147.611 33.8261 153.749 41.3973 153.749C44.6751 153.749 47.6843 152.598 50.0431 150.679",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1538 124.081C22.6453 128.003 20 133.594 20 140.04C20 151.857 29.5799 161.437 41.3973 161.437C46.6372 161.437 51.4596 159.624 55.2045 156.576",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.784 143.379C128.567 153.637 137.513 161.437 148.281 161.437C153.278 161.437 157.883 159.758 161.561 156.932",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.3 143.239C134.929 150.002 141.019 155.026 148.281 155.026C151.605 155.026 154.684 153.974 157.202 152.183L156.622 151.368C154.268 153.042 151.391 154.026 148.281 154.026C141.574 154.026 135.937 149.444 134.331 143.239H133.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.435 143.239C142.735 145.691 145.313 147.361 148.281 147.361C150.64 147.361 152.752 146.306 154.172 144.644L153.411 143.995C152.174 145.444 150.335 146.361 148.281 146.361C145.89 146.361 143.789 145.116 142.592 143.239H141.435Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.203 23.0951C110.203 24.7042 109.815 26.1366 109.214 27.1499C108.607 28.174 107.839 28.6902 107.088 28.6902C106.337 28.6902 105.568 28.174 104.961 27.1499C104.36 26.1366 103.972 24.7042 103.972 23.0951C103.972 21.486 104.36 20.0536 104.961 19.0403C105.568 18.0162 106.337 17.5 107.088 17.5C107.839 17.5 108.607 18.0162 109.214 19.0403C109.815 20.0536 110.203 21.486 110.203 23.0951Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.267 138.923H172.175H269.658C271.772 138.923 273.507 137.277 273.848 135.191C275.762 123.473 283.796 105.546 305.027 105.546C326.21 105.546 333.71 123.612 335.29 135.476C335.575 137.62 337.333 139.337 339.495 139.337H446.21C448.589 139.337 450.435 137.269 450.495 134.89C450.796 123.006 456.998 105.488 480.876 105.488C504.96 105.488 512.323 123.307 513.367 135.194C513.566 137.453 515.368 139.337 517.636 139.337H531.78C533.989 139.337 535.78 137.549 535.78 135.339V117.426C535.78 115.837 535.307 114.753 534.615 114.029C532.911 112.246 530.256 110.552 530.256 108.086V82.9687C530.256 81.4381 529.362 80.0252 527.985 79.3553C474.342 53.2443 448.944 40.8967 377.316 40.8967C293.32 40.8967 271.348 63.3257 254.409 75.1991C253.751 75.6609 252.967 75.8959 252.163 75.9042C217.204 76.2677 185.407 91.9224 172.136 100.801C171.059 101.521 170.448 102.733 170.448 104.028V126.833H169.267C167.058 126.833 165.267 128.624 165.267 130.833V134.923C165.267 137.132 167.058 138.923 169.267 138.923Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.892 75.7835H314.57C315.878 75.7835 317.088 75.1491 317.88 74.1091C327.056 62.0651 350.98 40.8967 383.164 40.8967",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.199 127.55C269.477 127.55 229.174 127.55 224.915 127.55C224.915 123.745 222.406 122.268 220.054 121.569C218.332 121.057 216.51 120.994 214.714 120.994C199.082 120.994 190.877 120.994 185.092 120.994C178.983 120.994 176.905 124.363 176.63 126.806H170.499",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.281,
    y: 109.568,
    width: 20.2245,
    height: 5.38513,
    rx: 2.69257,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.16 102.523H218.238",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.781 101.587C221.701 101.587 219.136 110.497 218.864 114.953C226.108 114.783 242.33 114.442 249.268 114.442C256.206 114.442 259.369 105.872 260.083 101.587H229.781Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.568 101.587C179.649 101.587 182.213 110.497 182.485 114.953C179.781 114.889 174.712 114.815 170.455 114.73",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.272 101.544C267 94.3873 285.202 81.5057 310.018 80.7523",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.351 109.604C305.5 109.096 299.628 109.179 297.633 109.179C294.575 109.179 289.532 110.238 286.849 111.391M306.363 161.246C304.652 161.676 297.342 161.246 295.512 161.246C283.24 161.246 273.151 151.043 271.975 137.982",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.72,
    cy: 135.425,
    rx: 23.6516,
    ry: 25.821,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.668 161.246C215.958 161.676 208.648 161.246 206.818 161.246C194.901 161.246 185.043 151.625 183.405 139.11",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.578 138.835C196.107 151.484 206.022 161.246 218.025 161.246C230.029 161.246 239.944 151.484 241.473 138.835",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.659 139.121C210.045 143.305 213.715 146.295 218.025 146.295C222.336 146.295 226.006 143.305 227.392 139.121",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.523,
    cy: 108.27,
    rx: 4.01816,
    ry: 5.71997,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.767 108.27C180.767 111.429 179.15 113.99 177.155 113.99C175.16 113.99 173.542 111.429 173.542 108.27C173.542 105.684 174.626 103.499 176.114 102.791",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.544,
    cy: 108.27,
    rx: 4.20468,
    ry: 5.71997,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.749 76.0077C251.337 70.6858 256.028 65.8113 263.921 65.8113C265.101 65.8113 266.178 65.9159 267.157 66.11",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69208 86.7018H54.068",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69208 162H289.663",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69208 79.0472H58.6921",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.689 79.0472H224.689",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3559_21736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 172,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalEvs);
export default __webpack_public_path__ + "static/media/personal-evs.34bf4e1fbd23f17a38ce30f8f0aa990f.svg";
export { ForwardRef as ReactComponent };